import React, { FC, useMemo, useRef } from "react"
import {
    APIJobModel,
    JobStatus,
    JobVersionItem
} from "../../../../../../../../Models/API/JobModel"
import { relativeAndAbsoluteDateTime } from "../../../../../../../../Helpers/Functions/dateFormat"
import { Property } from "dash-styled"

interface JobDetailViewDetailsSection {
    job: APIJobModel
    versionsList: JobVersionItem[]
}

export const JobDetailViewDetailsSection: FC<JobDetailViewDetailsSection> = ({
    job,
    versionsList
}) => {
    const ref = useRef<HTMLDivElement>(null)
    const earliestVersion = useMemo(
        () => versionsList[versionsList.length - 1],
        [versionsList]
    )

    const workerExists =
        job.workers !== null &&
        (job.workers.ais !== null ||
            job.workers.crowd === true ||
            job.workers.users !== null)

    return (
        <div
            ref={ref}
            className="text-rhino-700 text-sm"
            data-testid="job-detail-view-details"
        >
            <dl className="pl-5 pt-4">
                {workerExists && (
                    <Property name="Workers involved">
                        <ul>
                            {job.workers?.ais?.map(ai => (
                                <li key={ai}>{ai} (AI model)</li>
                            ))}
                            {job.workers?.users?.map(user => (
                                <li key={user}>{user} (Human worker)</li>
                            ))}
                            {job.workers?.crowd === true && (
                                <li>super.AI workers</li>
                            )}
                        </ul>
                    </Property>
                )}
                {earliestVersion.created === null ? null : (
                    <Property
                        name={
                            versionsList.length > 1
                                ? "Originally created "
                                : "Created "
                        }
                    >
                        {relativeAndAbsoluteDateTime(earliestVersion.created)}
                    </Property>
                )}
                {job.status === JobStatus.COMPLETED ? (
                    <Property name="Completed">
                        {relativeAndAbsoluteDateTime(job.completed)}
                    </Property>
                ) : null}
            </dl>
        </div>
    )
}
